import { Badge, Dropdown } from "antd"
import cx from "clsx"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import { Button, Checkbox, Flex, Group, Icon, RadioButtons } from ".."
import styles from "./index.module.less"

export const CheckboxRadiobuttonDropdown = props => {
  const { t } = useTranslation()
  const { data, disabled, values, onApplyFilter, labelKey = "label" } = props

  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [selectedNodes, setSelectedNodes] = useState({})

  const [searchParams, setSearchParams] = useSearchParams()
  const previousQueryObj = useMemo(() => Object.fromEntries([...searchParams]), [searchParams])

  useEffect(() => {
    let obj = {}
    data?.forEach(item => {
      if (previousQueryObj[item?.key]) {
        obj[item?.key] = {
          value: previousQueryObj[item?.key],
          ...(item?.children && { default: previousQueryObj[item?.key] }),
        }
      }
    })
    setSelectedNodes(obj)
  }, [previousQueryObj, data])

  const onClear = () => {
    data?.forEach(item => {
      if (previousQueryObj[item?.key]) {
        delete previousQueryObj[item?.key]
      }
    })
    setSearchParams({ ...previousQueryObj })
    setSelectedNodes([])
    setDropdownVisible(false)
  }

  return (
    <Dropdown
      open={dropdownVisible}
      onOpenChange={visible => setDropdownVisible(visible)}
      disabled={disabled}
      width={300}
      trigger={["click"]}
      dropdownRender={() => (
        <div className={cx(styles.dropdownContent, "p-16")} style={{ width: 320 }}>
          {data?.map((item, index) => (
            <Flex vertical gap="8px" align="start">
              <Checkbox
                checked={selectedNodes[item?.key]?.value}
                onChange={e => {
                  if (!e?.target?.checked) {
                    setSelectedNodes(prev => {
                      delete prev[item.key]
                      return { ...prev }
                    })
                    delete previousQueryObj[item.key]
                    return
                  }

                  setSelectedNodes(prev => ({
                    ...prev,
                    [item?.key]: {
                      value: e?.target?.checked,
                      ...(item?.children && { default: item?.children?.[0]?.value }),
                    },
                  }))
                }}
              >
                {item?.label}
              </Checkbox>
              <Flex vertical align="start" className="mbe-8">
                {item?.children && selectedNodes[item?.key] && (
                  <RadioButtons
                    style={{ flexDirection: "column", alignItems: "start" }}
                    value={selectedNodes[item?.key]?.default}
                    options={item?.children}
                    onChange={e => {
                      if (selectedNodes[item?.key]) {
                        setSelectedNodes(prev => {
                          selectedNodes[item.key]["default"] = e.target.value
                          return { ...prev }
                        })
                      }
                    }}
                  />
                )}
              </Flex>
            </Flex>
          ))}

          <div>
            <Group template={"1fr 1fr"} gap="8px" className={styles.dropdownTreeFooter}>
              <Button
                bordered
                variant="skeleton"
                onClick={onClear}
                disabled={Object.keys(selectedNodes)?.length <= 0}
                text={t("Reset All")}
                className={styles.reset}
                block
                size="small"
              />
              <Button
                text={t("Show Results")}
                type="primary"
                size="small"
                onClick={() => {
                  let queryObj = Object.keys(selectedNodes).reduce((obj, key) => {
                    obj[key] = selectedNodes[key]?.default ?? selectedNodes[key]?.value
                    return obj
                  }, {})

                  setDropdownVisible(false)
                  setSearchParams({ ...previousQueryObj, ...queryObj })
                }}
                block
              />
            </Group>
          </div>
        </div>
      )}
    >
      {Object.keys(selectedNodes)?.length ? (
        <Badge
          count={Object.keys(selectedNodes)?.length}
          offset={[4, 0]}
          size="small"
          status="success"
          className={styles.filterBadge}
        >
          <Icon icon="SvgIcSetting" size="20px" />
        </Badge>
      ) : (
        <Icon icon="SvgIcSetting" size="20px" />
      )}
    </Dropdown>
  )
}
